/**
 * Teaching-surface / bite-type slide metadata contract (UPPERCASE, absent =
 * SLIDE/INSTRUCTIONAL). Mirrors backend/constants/teaching.py and et-studio
 * features/slide/constants/teaching.ts — keep the three in sync.
 * Spec: docs/superpowers/specs/2026-07-20-teaching-surface-bite-type-design.md
 */
export const TEACHING_SURFACE = {
  SLIDE: "SLIDE",
  NOTEPAD: "NOTEPAD",
} as const;

export type TeachingSurface =
  (typeof TEACHING_SURFACE)[keyof typeof TEACHING_SURFACE];

export const BITE_TYPE = {
  INSTRUCTIONAL: "INSTRUCTIONAL",
  PRACTICE: "PRACTICE",
} as const;

export type BiteType = (typeof BITE_TYPE)[keyof typeof BITE_TYPE];
